"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("./specificProduct/index.vue"));
var _monitoringStatistics = _interopRequireDefault(require("./monitoringStatistics"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PriceMonitoring',
  components: {
    SpecificProduct: _index.default,
    MonitoringStatistics: _monitoringStatistics.default
  },
  data: function data() {
    return {
      activeName: 'first'
    };
  },
  mounted: function mounted() {
    // 查看系统消息跳转携带参数
    if (this.$route.query.activeName) this.activeName = this.$route.query.activeName;
    this.getDetail(this.activeName);
  },
  methods: {
    // tab点击切换
    handleClick: function handleClick(tab) {
      console.log(tab);
      if (!tab.name) return;
      var newActiveName = tab.name;
      // 先更新 activeName
      this.activeName = newActiveName;
      this.getDetail(newActiveName);
    },
    // 获取对应tab的数据
    getDetail: function getDetail(tabName) {
      var _this = this;
      this.$nextTick(function () {
        switch (tabName) {
          case 'first':
            // 监测大屏
            _this.$refs.monitoringStatisticsRef.getDashboardStatistics();
            _this.$refs.monitoringStatisticsRef.priceTrend();
            break;
          case 'second':
            // 监测商品列表
            _this.$refs.specificProductRef.handleSearchList();
            break;
        }
      });
    }
  }
};